const importantNotes = [
  {
    type: "note",
    category: [`directions`],
    text: `<strong>Direction Regarding Presentation of Offers (DRPO): </strong>
    If completed, this form must be uploaded to the MLS® System within 24 hours or 
    on activation of the listing. If at any point the details of the directions 
    change, you must immediately notify all cooperating brokerages that have 
    requested showings or expressed interest in presenting an offer and give them all 
    equal opportunity to submit an offer. If choosing to delay, the specific date 
    and time must be explicitly stated in both the public and REALTOR® Remarks 
    sections on MLS® listings.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is important to identify your client(s) before proceeding with
    signing an agreement to verify the names on the agreement are correct
    and all parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `<strong>Estate or Power of Attorney Listings:</strong> For an estate, list 
    and sign as: [Executor/Administrator Name], [Executor/Administrator] of the Estate 
    of [Deceased's Full Name]. For a Power of Attorney, the signer would sign as 
    "[POA Name], as attorney for [Principal's Full Legal Name]". 
    The supporting documents are required to prove those signing the documents 
    have the authority to do so. Depending on the situation, documents such as 
    the Grant of Probate or Power of Attorney documents are required to prove 
    signing authority.`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `Manufactured homes may only be offered for sale in BC if they bear an 
    approval mark such as a Canadian Standards Association (CSA) certification 
    label (sticker) or a Technical Safety Authority (TSBC) Silver Label. Educate 
    your client on the importance of the CSA Sticker, Silver Label, and retention 
    of all electrical permits.`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `When providing services to clients who want to buy or sell a Manufactured 
    Home—regardless of the home's type, location, or registration status—you must 
    verify two things: an up-to-date, valid electrical certification and a 
    Manufactured Home Registry search.`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `Be sure to obtain copies of all electrical permits if any alterations 
    have occurred to the manufactured home. If permits not available, wiring must 
    be inspected by a licensed electrical contractor or an accredited inspection 
    body (Electrical Inspector). Any additions/outbuildings will be good indicators 
    that modifications have likely occurred.`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `<strong>Manufactured Home Registry Search (Must be Completed): </strong> 
    <ol>
    <li>Registered Home: Verify that the owner's name matches the Seller's and—if the 
    home is on land—also matches the name on the property title. Verify that the 
    MHR# and serial number match the labels affixed to the manufactured home and 
    the numbers shown in the BC Assessment Authority property search, and confirm 
    the make, model, and size match the home. If it does not match, contact your 
    Managing Broker.</li>
    <li>Not Registered (exempt) and sold with land: The MHR search usually won't 
    match the current seller(s); it shows the owner at the time the home was 
    exempted. For homes sold with land, owners may have a s.21 Manufactured Home 
    Act exemption from MHR registration—this does not waive the s.21 requirement 
    for a valid CSA sticker. Verify that the MHR number and serial number match the 
    labels affixed to the manufactured home and the entries in the BC Assessment 
    property search, and that the make, model, and size match the home.</li>
    </ol>`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `<strong>Manufactured Home on Land: </strong> 
    Always include the MHR#, serial number, and CSA# (or TSBC Silver Label #) in 
    the legal description; otherwise, a manufactured home that hasn't been 
    de-registered may not be transferable to the new owner. If not exempt, advise 
    your Buyer to seek legal advice on the merits of de-registering the home.`,
  },
  {
    type: "note",
    category: [`Manufactured`],
    text: `<strong>Park Owner Consent: </strong> 
    Park owners have up to 10 days to consider the request. If the homeowner does 
    not receive a response within 10 days, the park owner's consent is deemed. A 
    park owner may withhold consent only on the permitted grounds set out in the 
    regulation. The regulation also clarifies the meanings of “assignment” and 
    “sublet.”`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Have your clients obtain a lawyer that is both experienced and
    comfortable doing assignment agreements. All questions regarding GST should 
    be directed to your client's lawyer and/or accountant.`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Most Builder's Purchase Contracts include an assignment fee; review the 
    Original Purchase Contract to determine the amount of the assignment fee.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `<strong>FINTRAC Receipt of Funds:</strong> Required when deposit is
    going to a brokerage trust account. Typical situations when ROF is not
    required include when the deposit goes directly to a builder or lawyer's
    trust account.`,
  },

  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `Ensure your Buyer Agency Exclusive Contract (BAEC) is signed on or before 
    the contract offer date.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `It is important to identify your Buyer clients before proceeding with 
    signing an agreement, to ensure the names on the agreement are correct and all 
    parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`, `listing`],
    text: `“Time is of the essence” when it comes to contracts. Make sure that 
    contracts and related deal documents are signed within their designated time 
    frames to best protect your clients.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`, `listing`],
    text: `If there is a tenant/extended family member living in the property ensure 
    you have completed the Mutual Agreement to End a Tenancy Form.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `Most boards require listings to go live within three days of the contract’s effective date; anything later will be rejected and cannot be posted on the MLS.`,
  },
  {
    type: "note",
    category: [`assignListing`],
    text: `Obtain a copy of the original contract and review it for assignment 
    restrictions—for example: requiring the developer's salesperson, needing developer 
    approval, prohibiting advertising, imposing assignment fees, or banning assignments 
    altogether.`,
  },
  {
    type: "note",
    category: [`assignListing`],
    text: `If the original contract prohibits advertising, use an exclusive listing 
    contract, as the property cannot be placed on the MLS.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Referrals or other payments must be paid through the brokerage.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Please wait until there is a FIRM deal before opening a referral transaction 
    in SkySlope. When creating your file, enter $1.00 as the purchase price and commission. 
    Enter "N/A" for any unknown fields.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `For internal referrals, do not open a new SkySlope file. Instead, have the 
    primary agent include you on the Deal Sheet.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Double check you have selected the correct referral form before submitting 
    it to the appropriate party.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Presales must follow REDMA guidelines - 
    <a href="https://www.bclaws.gov.bc.ca/civix/document/id/complete/statreg/04041_01" target="_blank" rel="noopener noreferrer">REDMA Presale Guidelines</a>`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `For more information on presales visit the BCFSA website - 
    <a href="https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/guidelines/presales-guidelines" target="_blank" rel="noopener noreferrer">BCFSA Presales Guidelines</a>`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Commission for presales is typically calculated on the sale price net of GST. 
    eXp will only approve advances if the contract does not contain a "clawback" clause.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Deposit structures for presales are typically paid in installments. Ensure 
    your client understands the deposit structure and the timing of the payments.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Not all presales can be assigned; therefore, it is important to read the 
    contract. If it can be assigned, there are likely fees and restrictions 
    associated with the assignment.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `The 7-day right of rescission allows buyers to cancel any presale contract 
    within 7 days, starting the same day the period begins. This period only starts 
    once two conditions are met: the Buyer has signed the Disclosure Statement 
    acknowledgment and the purchase contract is fully executed and agreed upon by 
    both parties.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `<strong>Closing Procedure:</strong> Please email
    <a href="mailto:bcpayouts@exprealty.net">bcpayouts@exprealty.net</a>
    once the tenants have taken possession. This will trigger the closing
    process so that commissions can be disbursed.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Once a fixed term lease is up, the tenancy automatically becomes 
    month-to-month regardless of what is agreed upon. A tenant cannot be evicted 
    without a valid reason. 
    <a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/ending-a-tenancy/evictions/types-of-evictions#landlord" target="_blank" rel="noopener noreferrer">More information on evictions.</a>`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Ensure that your services do not extend beyond preparing & negotiating the lease
    or tenancy agreement. All landlord and tenant matters should be handled between the 
    landlord and tenant, not the REALTOR®.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Credit checks must only collect information that is legal and appropriate. 
    They must comply with the Personal Information Protection Act (PIPA) and follow 
    the Privacy Commissioner's guidelines for private sector landlords and tenants. 
    Credit checks can be obtained through Landlord BC.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Property Management Services are not allowed. This includes collecting monthly 
    rent from tenants, handling maintenance requests, or any other property management 
    duties. Only placement services are allowed.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `FINTRAC documents are not required on leases. However, it is important
    to check the identification of your client(s).`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Ensure you have read and understand the Residential Tenancy Act,
    or you may put your client, the brokerage, and yourself at risk. Do not
    include any unenforceable clauses.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Verify the unit is legal and has met fire, electrical and zoning
    requirements with the Municipality.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `In addition to your client, it is important to identify the Seller(s) in
    this type of transaction to verify they have authority to sell the
    property.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `Deposit should be held in eXp trust account or a lawyer's and NEVER 
    directly to the Seller.`,
  },

  {
    type: "note",
    category: [`listing`],
    text: `If your listing sells in a multiple offer scenario, please upload all
    offers to your deal in SkySlope.`,
  },
  {
    type: "note",
    category: [`letterOpinion`],
    text: `Since the transaction staff will be creating an invoice for the client, 
    please be sure to include contact information (ie. Email Address) so that the 
    invoice can be sent out. Alternatively, the transaction staff can provide you
    the invoice for you to send to the client.`,
  },
  {
    type: "note",
    category: [`exclusiveListing`],
    text: `<strong>Exclusive Listings:</strong> In accordance with the REALTOR® Cooperation Policy, Members must, 
    within three (3) calendar days of any Public Marketing, place the Listing on 
    the MLS® System for cooperation with other REALTORS®. Check with your local real 
    estate board for any additional restrictions.The following Listings 
    are exempt from the requirements above: rental, commercial, agricultural, 
    new construction in developments with multiple units, and assignments of pre-con 
    properties where title has not been transferred. See the following 
    link for more information: 
    <a href="https://www.CREA.ca/REALTORCooperation" target="_blank" rel="noopener noreferrer">CREA.ca/REALTORCooperation</a>`,
  },
  /*
  
  {
    type: "note",
    category: [`mls`],
    text: `Please ensure that the commencement date on your Listing Agreement
    matches the contract start date on MLS.`,
  },
 
 
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `If it's a Pre-Con assignment, builders' consent is typically required,
    and so the builder consent clause should be included. In addition, it is always 
    recommended to have lawyer review conditions in the agreement as these
    can be complex transactions.`,
  },
  {
    type: "note",
    category: [`assignListing`],
    text: `It is important to check the original purchase contract or speak with
    the builder to find out if the property can be advertised (both MLS and public 
    websites).`,
  },
  {
    type: "note",
    category: [`assignPurchase`],
    text: `Thoroughly inspect the original purchase contract to understand the 
    specifics of the assignment for your client.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `<strong>Corporation Listings: </strong>If a corporation is listing a
    property, it is important to obtain supporting documents, such as the
    Articles of Incorporation, to ensure the parties signing the agreement
    have the authority to do so on behalf of the Corporation.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is the responsibility of the listing agent to make sure that all 
    details on the listing are correct. Please verify all listing details with your
    client, by carrying out the activities yourself (example: measurements)
    and other professional tools (example: GeoWarehouse).`,
  },
  {
    type: "note",
    category: [`mere`],
    text: `In a mere posting situation, as per TRESA, the Listing Brokerage still provides 
    representation to the Seller client.`,
  },
  
  */
];

export default importantNotes;
